/**
 * Collision-resistant ID generator for client-created master records.
 *
 * Previously, Master pages minted IDs as `${prefix}${String(list.length + 1).padStart(3, '0')}`.
 * That formula reuses an old ID the moment the list has ever been shorter than it
 * "should" be (after any delete, or simply from two people adding a record around
 * the same time from two tabs) — e.g. delete row 3 of 6, then add one: length is 5,
 * so the new record is assigned id "…006", which already belongs to the untouched
 * row 6. The backend's create is an upsert (INSERT ... ON CONFLICT DO UPDATE), so
 * that collision silently overwrites row 6's real data with the new form's values —
 * exactly the "master record got reset/cleared" symptom. Basing the id on the
 * current time (plus a random suffix) instead of the array length makes a repeat
 * essentially impossible, independent of deletes or concurrent editors.
 */
export function genId(prefix: string): string {
  return `${prefix}${Date.now().toString(36).toUpperCase()}${Math.random().toString(36).slice(2, 6).toUpperCase()}`
}
